import { Box, Layer, Text } from 'grommet';
import React from 'react';
import "./AssignModal.css";
import assign from '../../../../../../../assets/assign-modal.gif';
import { useStore } from '../../../../../../../Hooks/useStore';
import { useNavigate } from 'react-router-dom';

const AssignToSomeoneModal = ({ isShow, emsName, userType }) => {
    const { rootStore } = useStore();
    const navigate = useNavigate();
    const onGoHomeClick = () => {
        rootStore.emsStore.handleAssignToSomeoneModal(false);
        rootStore.emsStore.handleSelectEmsId("");
        rootStore.emsStore.resetSelectedMedicalIdListEms();
        rootStore.emsStore.resetSelectedMedicalIdList();
        rootStore.emsStore.handleNewEmergency();
    }
    return (
        <>
            {
                isShow
                    ?
                    <Layer>
                        <Box className='assign-modal-container'>
                            <img src={assign} className='assing-modal-img' />
                            <p className="assign-incident-desc">Medical Incident is assigned to <Text className='assign-whom'>{rootStore.emsStore.getSelectedEmsId}</Text></p>
                            <button onClick={() => onGoHomeClick()} className='assing-modal-btn'>Back to Medical Incidents</button>
                        </Box>
                    </Layer>
                    :
                    null
            }
        </>
    );
}

export default AssignToSomeoneModal;